import { AppServices } from "@singularsystems/neo-core";
import { IDashboardApiClient } from "./ApiClients/DashboardApiClient";
import ExportApiClient from "./ApiClients/ExportApiClient";
import { IReportingApiClient } from "./ApiClients/ReportingApiClient";

// Symbols to expose outside of this module
export const DomainExportedTypes = {
    ApiClients: {
        DashboardApiClient: new AppServices.ServiceIdentifier<IDashboardApiClient>("ApiClients.Dashboard"),
        ExportApiClient: new AppServices.ServiceIdentifier<ExportApiClient>("ApiClients.Export"),
        Reporting: new AppServices.ServiceIdentifier<IReportingApiClient>("ApiClients.Reporting")
    },
    Services: {
        
    }
}